import {
  Container,
  Group,
  Text,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { useAppSelector } from "../../app/hooks";
import AlbumList from "./AlbumList";
import { AlbumSlideshowExample } from "./slideshow";

export default function AlbumsView() {
  const profileState = useAppSelector((state) => state.profile);

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const colorScheme = useComputedColorScheme();

  // TODO: remove
  if (false) {
    return <AlbumSlideshowExample />;
  }

  return (
    <Container
      className="w-full mx-auto flex flex-col gap-4"
      p={isMobile ? "md" : "xl"}
      maw={null}
    >
      <Group justify="space-between" align="center" mb="0">
        <Text fz="xl" className="title" fw={500}>
          Albums
        </Text>
      </Group>

      <AlbumList></AlbumList>
    </Container>
  );
}
